import _ from 'lodash'
import register from './util/register'
import angular from 'angular'
import configure from './app.config'
import ngRoute from 'angular-route'
import ngStorage from 'ngstorage'
import 'angular-ui-bootstrap'
import BodyController from './index/BodyController'
import FlashFactory from './util/flash.factory.js'
import ConfigurationFactory from './util/configuration.factory.js'
import Base64 from './util/base64.service.js'

require('../views/templates')

/* Modules */
import './signup/signup.module'
import './auth/auth.module'
import './password-reset/password-reset.module'
import './nav/nav.module'
import './detail/detail-result.module'
import './upgrade-teaser/upgrade-teaser.module'
import './results-grid/results-grid.module'
import './search-form/search-form.module'
import './search-results/search-results.module'
import './search/search.module'
import './contact/contact.module'
import './account-management/account-management.module'
import './alerts-management/alerts-management.module'
import './alerts-management/alert-count.module'
import './alerts-history/alerts-history.module'
import '../blocks/analytics/analytics.module'

var app = angular.module(
  'app',
  [
    'ui.bootstrap',
    'ngRoute',
    'ngStorage',
    'app.templates',
    'app.auth',
    'app.passwordReset',
    'app.nav',
    'app.signup',
    'app.resultsGrid',
    'app.searchForm',
    'app.detailResult',
    'app.searchResults',
    'app.search',
    'app.contact',
    'app.accountManagement',
    'app.signup',
    'app.alertsManagement',
    'app.alertsHistory',
    'app.alertCount',
    'blocks.analytics'
  ]
)

register('app')
  .controller('BodyController', BodyController)
  .factory('flash', FlashFactory)
  .factory('config', ConfigurationFactory)

app.config(configure)

app.run(function($window, $rootScope, $location, flash, $log, $httpParamSerializer) {
  // Some of our 3rd-party libraries require lodash on the global scope.
  $window._ = _

  $rootScope.$on("$routeChangeError", function(event, previous, current, rejection) {
    console.log("error")
    if (rejection == 401) {
      const redirectUrl = previous.originalPath + "?" + $httpParamSerializer(previous.params)
      $log.debug("Redirect URL: " + redirectUrl)
      flash.setMessage("Login first to access the site")
      $location.url("/login?redirectTo=" + encodeURIComponent(redirectUrl))
    } else {
      $location.path("/search");
    }
  });
})
